import * as React from "react";
const SvgLocation = () => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, fill: "none" }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 2.75c-3.598 0-7.25 2.53-7.25 6.869 0 .978.428 2.2 1.159 3.545.721 1.327 1.692 2.69 2.678 3.928a51 51 0 0 0 2.709 3.115.966.966 0 0 0 1.408 0 51 51 0 0 0 2.71-3.115c.985-1.237 1.956-2.601 2.677-3.928.73-1.344 1.159-2.567 1.159-3.545 0-4.34-3.652-6.869-7.25-6.869M12 22l-.52.54-.003-.002-.005-.005-.018-.018-.07-.068-.26-.259a52.117 52.117 0 0 1-3.711-4.161C6.4 16.753 5.37 15.313 4.591 13.88c-.77-1.415-1.341-2.906-1.341-4.262C3.25 4.244 7.798 1.25 12 1.25s8.75 2.994 8.75 8.37c0 1.355-.572 2.846-1.341 4.26-.779 1.433-1.808 2.873-2.822 4.147a52 52 0 0 1-3.971 4.42l-.07.068-.018.018-.007.006zm0 0 .521.54a.75.75 0 0 1-1.042 0z",
    clipRule: "evenodd"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 7.512c-1.277 0-2.25.977-2.25 2.107s.973 2.107 2.25 2.107 2.25-.978 2.25-2.107-.973-2.107-2.25-2.107M8.25 9.619c0-2.026 1.714-3.607 3.75-3.607s3.75 1.58 3.75 3.607c0 2.026-1.714 3.607-3.75 3.607s-3.75-1.58-3.75-3.607",
    clipRule: "evenodd"
  }
));
export default SvgLocation;
